import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
const FundtransferBtn = (props) => {
    return (React.createElement("div", { className: ` ${props.parentClass} bottombtngroup d-flex justify-content-around align-content-center` },
        React.createElement(React.Fragment, null,
            props.btnvalueleft && React.createElement(EdButton, Object.assign({}, props.btnvalueleft)),
            props.btnvalueright && React.createElement(EdButton, Object.assign({}, props.btnvalueright)))));
};
export default FundtransferBtn;
